var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v("Third Party Devices"),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-content device-list" }, [
      _c(
        "div",
        { staticStyle: { "min-height": "100px" } },
        [
          _c(
            "el-table",
            {
              staticClass: "table__header-subtitles",
              attrs: {
                "row-class-name": "device-table-row-style",
                "cell-class-name": "device-table-cell-style",
                data: _vm.thirdPartyDevices,
                "highlight-current-row": false,
              },
            },
            [
              _c("el-table-column", {
                attrs: { "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticStyle: { "text-align": "center" } },
                          [_c("DeviceImage", { attrs: { device: scope.row } })],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { "min-width": "160", label: "Device" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticStyle: { "padding-left": "10px" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "border-bottom": "solid 1px #ddd",
                                "margin-bottom": "10px",
                                "padding-bottom": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.name) +
                                  "\n                "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticStyle: { color: "#999" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm.product(scope.row).description ||
                                        scope.row.type
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "device-column" }, [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      target: "_blank",
                                      underline: false,
                                      href: scope.row.ring_solutions_url,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.deviceLinkText(scope.row)) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { "min-width": "200", label: "Owner" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-start",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("span", { staticClass: "owner-email" }, [
                              _vm._v(_vm._s(scope.row.owner_email)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { "min-width": "300", label: "Created At" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-start",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("time-zone-formatter", {
                              attrs: { "current-time": scope.row.created_at },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { "min-width": "300", label: "Updated At" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-start",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("time-zone-formatter", {
                              attrs: { "current-time": scope.row.updated_at },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          staticClass: "flex flex-col items-start",
                          attrs: { slot: "content" },
                          slot: "content",
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { "min-width": "120" } },
                [_c("template", { slot: "header" })],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }